import { MemberProfileExtendedType } from 'common/types/MemberProfile'
import { BadgeContainer } from '../../common/BadgeContainer'
import { ProfileBadge, ProfileBadgeVariant } from '../../common/ProfileBadge'

interface InformationBadgesProps {
  profile: MemberProfileExtendedType
}

interface BadgeSectionProps {
  title: string
  items: string[]
  variant: ProfileBadgeVariant
}

function BadgeSection({ title, items, variant }: BadgeSectionProps) {
  return (
    // wrapped in a div to ensure correct vertical spacing is applied
    <div>
      <BadgeContainer title={title}>
        {items.length === 0 && (
          <ProfileBadge text='Not provided' variant={variant} />
        )}
        {items.map((item: string) => (
          <ProfileBadge key={item} text={item} variant={variant} />
        ))}
      </BadgeContainer>
    </div>
  )
}

export function InformationBadges({ profile }: InformationBadgesProps) {
  return (
    <>
      <BadgeSection
        title='Languages'
        items={profile.professional_core.languages}
        variant='languages'
      />
      <BadgeSection
        title='Areas of law'
        items={profile.professional_core.areas_of_law}
        variant='areas_of_law'
      />
      <BadgeSection
        title='Legal services'
        items={profile.professional_core.legal_services}
        variant='legal_services'
      />
    </>
  )
}
